module.exports = __webpack_public_path__ + "static/img/four.6582bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appleImg/four.png
// module id = Kz1k
// module chunks = 1